import React from "react";
import UserChart from "./UserChart";
import FeedChart from "./FeedChart";

const DataAnalysis = () => {
  return (
    <section className="
      flex-1
      ml-0 sm:ml-[19rem]
      mt-[5rem] sm:mt-[8rem]
      rounded-xl bg-gray-200
      flex flex-col lg:flex-row flex-wrap
      items-start justify-start
      p-[1rem] sm:p-[2rem]
      box-border
      gap-[1.5rem]
      min-h-screen
      w-full sm:max-w-[calc(100%_-_300px)]
      text-left text-[1.625rem] text-white font-gilroy
    ">
      <div className="flex flex-col lg:flex-row gap-6 w-full">
        <UserChart />
        <FeedChart />
      </div>
    </section>
  );
};

export default DataAnalysis;